import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import { compareEntities } from '@lycoris-nubila/ngx-lycoris';
import { first, isEqual, isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { ModuleGraph } from 'module/page/graph/module-graph';
import { UserMood } from 'user/mood/user-mood';
import {
	UserMoodDocument,
	UserMoodsState,
	UserMoodsStore,
} from 'user/mood/user-mood.store';
import { UserMoodRepositoryPort } from 'user/port/mood/user-mood-repository.port';

import { CacheObservable } from '../../../app-decorators';

@Injectable()
export class UserMoodRepositoryAdapter
	extends QueryEntity<UserMoodsState>
	implements UserMoodRepositoryPort
{
	constructor(protected store: UserMoodsStore) {
		super(store);
	}

	public observeLatestUserMood(): Observable<UserMood> {
		return this.selectAll({
			sortBy: 'creationTimestamp',
			sortByOrder: Order.DESC,
		}).pipe(
			distinctUntilChanged<UserMoodDocument[]>(isEqual),
			map((documents) => first(documents)),
			map((document) => this.store.asEntity(document))
		);
	}
	@CacheObservable()
	public observeUserMoodsByIds(moodsId: string[]): Observable<UserMood[]> {
		return this.selectMany(moodsId).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
	public persistUserMoods(entities: UserMood[]): void {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
